export const dataToHTMLTable = (rows: any[][]) => {
  let result = '<table>';
  rows.forEach((columns) => {
    result += '<tr>';
    columns.forEach((value) => {
      result += `<td  style="mso-number-format:'@';">` + value + '</td>';
    });
    result += '</tr>';
  });
  result += '</table>';
  return result;
};
